import { MienbacDBLotto } from '../interfaces/mienbac-db-lotto';
import { MienbacLotto, MienbacVipLotto } from '../interfaces/mienbac-lotto';
import { MiennamLotto, MiennamVipLotto } from '../interfaces/miennam-lotto';
import { MientrungLotto } from '../interfaces/mientrung-lotto';
import { FastLotto } from '../interfaces/fast-lotto-bet';
import gameListInterface from '../pages/account/stats-general.interface';
import { LotteryInterface, NumHighlight } from '../models/lotteryModel';
import store from 'cache/store';
import userApi from 'apis/userApi';
import { cacheUserInfo } from 'features/authSlice';
import { numberWithCommas } from './time-utils';
import { ChipItem } from 'models/txcb-model';

export const checkWhiteSpaceString = (text: string) => {
    const isValid = /^\S+$/.test(text);
    return isValid;
};

export const removeSeperateNumber = (numberText: string) => {
    return numberText.replace(/[,]/g, '');
};

export const getFullLinkUrl = () => {
    let link = window.location.protocol + '//' + window.location.hostname;
    if (window.location.port !== '') {
        link += ':' + window.location.port;
    }
    return link;
};

export const rangeYear = (start: number, end: number) => {
    return (new Array(end - start) as any).fill().map((d: any, i: any) => i + start);
};

export const checkIsTypeLotteryMienNam = (lotteryId: number) => {
    const groupLotteryGame = gameListInterface.filter((group) => group.id === 'xosotruyenthong' || group.id === 'xosonhanh' || group.id === 'xosovip');
    let gameList: any[] = [];
    groupLotteryGame.forEach((game) => {
        gameList = [...gameList, ...game.gameGroup.filter((item) => item.gameId)];
    });
    gameList = gameList.filter((game) => game.id === 'mientrung' || game.id === 'miennam' || game.id === 'xosonhanh');
    gameList = gameList.map((game) => game.gameId);

    return gameList.includes(lotteryId);
};

export const checkIsTypeLotteryMienBac = (lotteryId: number) => {
    const groupLotteryGame = gameListInterface.filter((group) => group.id === 'xosotruyenthong' || group.id === 'xosonhanh' || group.id === 'xosovip');
    let gameList: any[] = [];
    groupLotteryGame.forEach((game) => {
        gameList = [...gameList, ...game.gameGroup.filter((item) => item.gameId)];
    });
    gameList = gameList.filter((game) => game.id === 'mienbac' || game.id === 'xosonhanh');
    gameList = gameList.map((game) => game.gameId);
    return gameList.includes(lotteryId);
};

export const checkIsFastLottery = (lotteryId: number) => {
    const groupLotteryGame = gameListInterface.filter((group) => group.id === 'xosonhanh');
    let gameList: any[] = [];
    groupLotteryGame.forEach((game) => {
        gameList = [...gameList, ...game.gameGroup.filter((item) => item.gameId)];
        gameList = gameList.map((game) => game.gameId);
    });
    return gameList.includes(lotteryId);
};

export const getTitleLottery = (lotteryId: number): string => {
    const groupLotteryGame = gameListInterface.filter((group) => group.id === 'xosotruyenthong' || group.id === 'xosonhanh');
    let gameList: any[] = [];
    groupLotteryGame.forEach((game) => {
        gameList = [...gameList, ...game.gameGroup.filter((item) => item.gameId)];
    });
    const lotterySelect = gameList.find((game) => game.gameId === lotteryId);
    if (lotterySelect) return lotterySelect.label;
    return '';
};

export const getLotteryFace = (ltid: number): LotteryInterface[] => {
    if (ltid > 49 && ltid < 105 && ltid !== 83 && ltid !== 85 && ltid !== 89) {
        return JSON.parse(JSON.stringify(FastLotto));
    } else if (ltid > 104 && ltid < 126) {
        return JSON.parse(JSON.stringify(MiennamLotto));
    } else if (ltid > 125 && ltid < 140) {
        return JSON.parse(JSON.stringify(MientrungLotto));
    } else if (ltid === 200) {
        return JSON.parse(JSON.stringify(MienbacLotto));
    } else if (ltid === 201) {
        return JSON.parse(JSON.stringify(MienbacDBLotto));
    } else if (ltid === 202 || ltid === 204 || ltid === 99) {
        return JSON.parse(JSON.stringify(MienbacVipLotto));
    } else if (ltid === 206 || ltid === 207) {
        return JSON.parse(JSON.stringify(MiennamVipLotto));
    }  else if (ltid > 209 && ltid < 234) {
        return JSON.parse(JSON.stringify(MienbacLotto));
    } else if (ltid > 139 && ltid < 146) {
        return JSON.parse(JSON.stringify(MienbacLotto));
    } else {
        return [];
    }
};

export const cloneObject = (obj: any) => {
    return JSON.parse(JSON.stringify(obj));
};

export const removeFormatMoney = (money: string) => {
    return money.replace(/[,]/g, "");
};

export const splitInputLottery = (slNums: string) => {
    slNums = slNums.replace(/((\s+)?,(\s+)?)/g, ',');
    slNums = slNums.replace(/((\s+)?;(\s+)?)/g, ';');
    slNums = slNums.replace(/\s+/g, ' ');
    slNums = slNums.trim();
    return slNums.split(/\;|\,| /);
};

export const extractTypeInNumbers = (input: string) => {
    if (!input) return [];
    return input.replace(/\D/g, ' ').split(' ');
};

export const getFormatHightLightLottery = (typeInputId: string, type: 'MB' | 'MBDB' | 'MN') => {
    let numHightLight: NumHighlight = {} as NumHighlight;
    let lotteryFace: LotteryInterface[] = [];
    if (type === 'MN') {
        lotteryFace = MiennamLotto;
    }
    if (type === 'MB') {
        lotteryFace = MienbacLotto;
    }
    if (type === 'MBDB') {
        lotteryFace = MienbacDBLotto;
    }
    lotteryFace.forEach((face) => {
        if (face.subTabs && Object.keys(numHightLight).length === 0) {
            face.subTabs.forEach((tab) => {
                if (tab.typeIputID === typeInputId) {
                    numHightLight = tab.numHl;
                }
            });
        }
    });
    return numHightLight;
};

export const scrollToTopPage = () => {
    const rootEl = document.getElementById('appRoot');
    if (rootEl) {
        rootEl.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
};

export const reloadBalance = async () => {
    const { userInfo } = store.getState().auth;
    try {
        const { data } = await userApi.balance({});
        if (!data.msg) {
            store.dispatch(cacheUserInfo({ ...userInfo, balance: data.balance }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const animateValue = (obj: HTMLElement, start: number, end: number, duration: number, callback: () => void) => {
    let startTimestamp: number | null = null;
    let i = 0;
    const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        i += 1;
        if (i % 3 === 0) {
            obj.innerHTML = numberWithCommas(Math.floor(progress * (end - start) + start));
        }
        if (progress < 1 && duration !== -1) {
            window.requestAnimationFrame(step);
        } else {
            callback();
        }
    };
    window.requestAnimationFrame(step);
};

export const chipMiniGameList: ChipItem[] = [
    {
        txt: '1K',
        val: 1000,
        isActive: false,
        icon: 'chip1.png',
    },
    {
        txt: '10K',
        val: 10000,
        isActive: false,
        icon: 'chip2.png',
    },
    {
        txt: '50K',
        val: 50000,
        isActive: false,
        icon: 'chip3.png',
    },
    {
        txt: '100K',
        val: 100000,
        isActive: false,
        icon: 'chip4.png',
    },
    {
        txt: '500K',
        val: 500000,
        isActive: false,
        icon: 'chip5.png',
    },
    {
        txt: '5M',
        val: 5000000,
        isActive: false,
        icon: 'chip6.png',
    },
    {
        txt: '10M',
        val: 10000000,
        isActive: false,
        icon: 'chip7.png',
    },
    {
        txt: '50M',
        val: 50000000,
        isActive: false,
        icon: 'chip8.png',
    },
];

export const copyToClipboard = (text: string) => {
    let documentBodyTemp = document.body;

    const textarea = document.createElement('textarea');
    const res: { status: boolean; msg: string } = { status: false, msg: '' };
    textarea.textContent = text;
    textarea.contentEditable = 'true';
    textarea.readOnly = false;
    textarea.style.background = 'transparent';
    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
    documentBodyTemp.appendChild(textarea);
    textarea.setSelectionRange(0, text.length);
    document.execCommand('copy');
    textarea.select();
    try {
        document.execCommand('copy'); // Security exception may be thrown by some browsers.
    } catch (ex) {
        res.status = false;
        res.msg = 'Sao chép thất bại!';
        return res;
    } finally {
        res.status = true;
        res.msg = 'Sao chép thành công!';
        documentBodyTemp.removeChild(textarea);
    }
    return res;
};
